<template>
	<div>
		<notifications group="global" />
        <nav class="navbar is-black">
<div class="container">
	<div class="navbar-brand">
		<a class="navbar-item" href="/cos">
		<img src="/circle-of-stars-logo.png" alt="Circle of Stars Logo" height="120px">
		</a>
		<a class="navbar-item phone" href="tel:18006810144">1-800-681-0144</a>
		<span class="navbar-burger burger" :class="{'is-active': menuOpen}" @click="toggleMenu">
		<span></span>
		<span></span>
		<span></span>
		</span>
	</div>
	<div id="navbarMenu" class="navbar-menu" :class="{'is-active': menuOpen}">
		<div class="navbar-end">
			<div class="tabs is-centered">
				<ul>
					<li class="is-active"><router-link :to="'/cos'">Home</router-link></li>
					<li><router-link :to="'/cos/apply'">Apply</router-link></li>
					<li><router-link :to="'/login'">Login</router-link></li>
				</ul>
			</div>
		</div>
	</div>
</div>
</nav>
        <slot />
        <footer class="footer is-black">
<div class="container">
	<div class="content has-text-centered">
		<p>
			Circle of Stars © 2005-{{year}}. All rights reserved.
		</p>
		<p class="seal">
			<img src="/new-seal-geo.png" alt="geotrust logo" height="120px">
		</p>
	</div>
</div>
</footer>
    </div>
</template>

<script>
export default {
	data() {
		return {
			menuOpen: false,
			year: new Date().getFullYear()
		}
	},
	methods: {
		toggleMenu() {
			this.menuOpen = !this.menuOpen
		}
	},
	created() {
		document.title = "Circle of Stars"
	},
	mounted() {
		document.querySelector("meta[name='description']").setAttribute("content", "Psychics, Phone Psychics, Mediums, Tarot Readers, Love and Relationship Expert, Psychic Jobs, Love Psychic Jpb, Psychic Career, Psychic Job, Work at home your own hours")
		document.querySelector("meta[property='og:description']").setAttribute("content", "Circle of Stars is seeking experienced heart-centered psychics who are gifted and committed to empowering and healing the lives of others....")
	}
}
</script>